// extracted by mini-css-extract-plugin
var _1 = "tjs-feature-info-catalog-item__message-item";
var _2 = "tjs-feature-info-catalog-item__message-item";
var _3 = "tjs-feature-info-catalog-item__sections tjs-_base__list-reset";
export { _1 as "message-item", _2 as "messageItem", _3 as "sections" }
export default { "message-item": _1, "messageItem": _2, "sections": _3 }
